























































































import { Component, Vue, Prop } from "vue-property-decorator";
import {
  getAssessList,
  getContent,
  delContents,
  getAllTemplate,
} from "@/request/custom";
import Read from "./read.vue";
import LeftList from "../../components/left-list/left-list.vue";
import Empty from "@/components/empty.vue";
@Component({
  components: {
    Read,
    LeftList,
    Empty,
  },
})
export default class Name extends Vue {
  private leftNavList: any = [];
  private detail: any = {};
  private redIndex: any = -1; // 需要标红提示未填的index
  private IfShowAdd: any = false;
  private IfShowEditTime: any = false;
  private addValue: any = "";
  private time: any = "";
  private editData: any = {};
  private options: any = [];
  private disabledEndDate: any = this.endDate();
  private endDate() {
    const self = this;
    return {
      disabledDate(time: any) {
        return time.getTime() > Date.now();
      },
    };
  }
  private get patient() {
    return this.$store.state.patient;
  }
  private get user() {
    return this.$store.state.user || {};
  }
  private get configuration() {
    return this.$store.state.configuration;
  }
  private get patientFileFilter() {
    return this.$store.state.patientFileFilter;
  }
  private delOne(e: any) {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      data: {
        content_id: e.content_id,
      },
    };
    delContents(this, params, loading)
      .then(() => {
        loading.close();
        this.$message.success("删除成功！");

        this.getLeftData().then((res: any) => {
          let obj: any = JSON.parse(JSON.stringify(this.patientFileFilter));
          if (res.contents.length > 0) {
            this.$store.commit(
              "updatePatientFileFilterRefrshTime",
              new Date().getTime()
            );
          } else {
            obj.thirdTab = "";
            this.$store.commit("updatePatientFileFilter", obj);
            this.detail = {};
          }
        });
      })
      .catch(() => {
        loading.close();
      });
  }
  private editTimeSure() {
    // 编辑后需要重新更新选中的数据
    this.getLeftData().then((res: any) => {
      res.forEach((ele: any) => {
        if (ele.content_id === this.patientFileFilter.thirdTab.content_id) {
          const d: any = JSON.parse(JSON.stringify(ele));
          this.$store.commit("updatePatientFileFilter", d);
          this.updateRightData();
        }
      });
    });
  }
  private focus(e: any) {
    if (e) {
      this.remoteMethod("");
    }
  }
  private remoteMethod(e: any) {
    const params: any = {
      search: e,
      need_score: true,
      checkState: true,
    };
    getAllTemplate(this, params).then((res: any) => {
      this.options = res;
    });
  }
  private openAdd() {
    this.IfShowAdd = true;
    this.addValue = "";
  }
  private addSure() {
    if (!this.addValue) {
      this.$message.warning("请选择测评量表！");
      return;
    }
    this.$router.push({
      path: "/main/workstation/patient-ceping-edit",
      query: {
        template_id: this.addValue,
      },
    });
  }
  private goEdit() {
    this.$store.commit("updateIfCompose", true);
    this.$router.push({
      path: "/main/workstation/patient-ceping-edit",
      query: {
        content_id: this.detail.content_id,
      },
    });
  }
  private getLeftData() {
    return new Promise((resolve, reject) => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params: any = {
        patient_id: this.patient.patient_id,
        page_count: "0",
      };
      getAssessList(this, params, loading)
        .then((d1: any) => {
          loading.close();
          this.leftNavList = d1.contents;
          resolve(d1);
        })
        .catch(() => {
          loading.close();
        });
    });
  }
  private updateRightData() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      content_id: this.patientFileFilter.thirdTab.content_id,
    };
    getContent(this, params, loading).then((res: any) => {
      this.detail = res;
    });
  }
  private mounted() {
    this.$store.commit("updateIfCompose", false);
    this.getLeftData().then(() => {
      // 如果没有选中项，默认选中第一个
      if (!this.patientFileFilter.thirdTab) {
        this.$store.commit(
          "updatePatientFileFilterRefrshTime",
          new Date().getTime()
        );
      } else {
        this.updateRightData();
      }
    });
  }
}
